// extracted by mini-css-extract-plugin
export default {"wrapper":"DeviceModal_wrapper__-4CRg","tips":"DeviceModal_tips__-3JM1","red":"DeviceModal_red__nRT83","meterTags":"DeviceModal_meterTags__51k+Y"};